import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "aetryx_token";
export const REFRESH_KEY = "aetryx_refresh";
export const PROFILE_KEY = "aetryx_profile";

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem(TOKEN_KEY);
  const profile = localStorage.getItem(PROFILE_KEY);
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  if (profile) cfg.headers["X-Profile-Id"] = profile;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    const code = error.response?.data?.detail?.code;
    if (code === "maintenance") window.dispatchEvent(new Event("aetryx:maintenance"));
    if (code === "mfa_required") { window.dispatchEvent(new Event("aetryx:mfa")); throw error; }
    if (error.response?.status !== 401 || cfg._retry || url.startsWith("/auth/")) throw error;
    if (!localStorage.getItem(TOKEN_KEY) && !localStorage.getItem(REFRESH_KEY)) throw error;  // guest: nothing to refresh
    cfg._retry = true;
    try {
      refreshing = refreshing || axios.post(`${API}/auth/refresh`, { refresh_token: localStorage.getItem(REFRESH_KEY) }, { withCredentials: true });
      let data;
      try { ({ data } = await refreshing); } catch (e) {
        localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(REFRESH_KEY);
        window.dispatchEvent(new Event("aetryx:logout"));
        throw error;
      }
      localStorage.setItem(TOKEN_KEY, data.access_token);
      return api(cfg);
    } finally {
      refreshing = null;
    }
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return detail.message || (typeof detail.msg === "string" ? detail.msg : String(detail));
}

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);
